<template>

<component-module moduleName="reports_module">
    <template v-slot:programName>Reports</template>
    <template v-slot:navigation>
        <div class="main-nav">
            <template v-if="dashboardMenuItem">
                <div v-if="dashboardMenuItem.not_allowed" class="not-allowed">Dashboard</div>
                <router-link v-else class="link" :to="'/' + dashboardMenuItem.link_value">Dashboard</router-link>
            </template>
            <template v-for="(menuItem, index) in mainMenu">
                <div v-if="menuItem.not_allowed" class="not-allowed" :key="'sub-menu-item-' + menuItem.menu_item_id">{{ menuItem.menu_label }}</div>
                <router-link v-else class="link" :to="(menuItem.link_type == 'LEGACY' ? '/legacy/' : '') + menuItem.link_value" :key="'sub_menu_item_' + menuItem.menu_item_id">{{ menuItem.menu_label }}</router-link>
            </template>
        </div>
        <div class="secondary-nav">
            <template v-for="(menuItem, index) in secondaryMenu">
                <div v-if="menuItem.not_allowed" class="not-allowed" :key="'sub-menu-item-' + menuItem.menu_item_id">{{ menuItem.menu_label }}</div>
                <router-link v-else class="link" :to="(menuItem.link_type == 'LEGACY' ? '/legacy/' : '') + menuItem.link_value" :key="'sub_menu_item_' + menuItem.menu_item_id">{{ menuItem.menu_label }}</router-link>
            </template>
        </div>
    </template>
</component-module>

</template>

<script>
import './reports.scss'
export default {
    created() {
        this.updateCustomModuleName('Reports');
    },
    computed: {
        mainMenu() {
            if (!this.getModuleNavMenu.sort_0) return {}
            return this.getModuleNavMenu.sort_0.menu_items
        },
        secondaryMenu() {
            if (!this.getModuleNavMenu.sort_1) return {}
            return this.getModuleNavMenu.sort_1.menu_items
        },
        dashboardMenuItem() {
            for (const [key, menuItem] of Object.entries(this.getFlightDeckMainMenu)) {
                if (menuItem.link_value == 'reports') {
                    return menuItem
                }
            }
        }
    }
}
</script>

<style>

</style>
